<template>
    <div>
        <b-row v-if="!hasImages">
            <b-col>{{ emptyText }}</b-col>
        </b-row>
        <b-row v-for="imgUrl in imageUrls" :key="imgUrl">
            <b-col>
                <a :href="imgUrl" target="_blank">
                    <img :src="imgUrl" class="patient-uploaded-image" />
                </a>
            </b-col>
        </b-row>
    </div>
</template>

<script lang="ts">
import { Vue, Prop } from 'vue-property-decorator';
import Component from 'vue-class-component';

@Component({
    name: 'PatientUploadedImagesModalComponent',
})
export default class PatientUploadedImagesModalComponent extends Vue {
    @Prop({ required: true, default: () => [] }) imageUrls!: string[];
    @Prop({ default: "There's no images." }) emptyText!: string;

    get hasImages(): boolean {
        return this.imageUrls?.length > 0;
    }
}
</script>

<style scoped>
.patient-uploaded-image {
    max-width: 100%;
    height: auto;
}
</style>
